import { post, put, deleteHttp, postFile, apiFetcher } from "./fetcher";

export const getInformations = (merchantCode) => {
  return post("api/informations", { merchantCode });
};
export const saveInformations = (merchantCode, informations) => {
  return put(`api/informations/initialization`, {
    merchantCode,
    ...informations,
  });
};
export const initialization = (merchantCode) => {
  return post("api/informations/initialization", { merchantCode });
};
export const duplicateCatalog = (merchantCode, sourceMerchantCode) => {
  return post("api/duplicate-catalog", { sourceMerchantCode, merchantCode });
};
export const getMerchantCategories = (merchantCode, kind) => {
  return post("api/merchant-categories", { merchantCode, kind });
};
export const uploadInformationsFile = (id, merchantCode, file, label) => {
  var data = new FormData();
  data.append("merchantCode", merchantCode);
  data.append("file", file);
  data.append("label", label);
  return postFile(`api/informations/${id}/upload`, data);
};
export const checkSlug = (merchantCode, slug) => {
  return post(`api/informations/check-slug`, {
    merchantCode,
    slug,
  });
};
export const deleteInformationsFile = (id, merchantCode, label) => {
  return deleteHttp(`api/informations/${id}/upload`, {
    merchantCode,
    label,
  });
};
export const geocoding = (query) =>
  apiFetcher(
    `https://api.opencagedata.com/geocode/v1/json?key=bd3ec33f4d484b7bba9b358da289caba&countrycode=fr,ch,it,es&q=${query}`
  );

export const getProductsGrouped = (merchantCode) => {
  return post("api/products", { merchantCode });
};
export const getProduct = (id, merchantCode) => {
  return post(`api/products/${id}`, { merchantCode });
};
export const getOptionableProducts = (merchantCode) => {
  return post(`api/products/optionable`, { merchantCode });
};
export const getCarriedSalesInformations = (merchantCode, productIds) => {
  return post(`api/products/carried-sales-informations`, {
    merchantCode,
    productIds,
  });
};
export const saveProduct = (id, merchantCode, product) => {
  return put(`api/products/${id}`, { merchantCode, product });
};
export const deleteProduct = (id, merchantCode) => {
  return deleteHttp(`api/products/${id}`, { merchantCode });
};
export const reoderProducts = (merchantCode, source, position, target) => {
  return post(`api/products/reorder`, {
    merchantCode,
    source,
    position,
    target,
  });
};
export const uploadProductPhoto = (id, merchantCode, file) => {
  var data = new FormData();
  data.append("file", file);
  data.append("merchantCode", merchantCode);

  return postFile(`api/products/${id}/upload`, data);
};
export const deleteProductPhoto = (id, merchantCode) => {
  return deleteHttp(`api/products/${id}/upload`, { merchantCode });
};

export const getCategories = (merchantCode) => {
  return post("api/categories", { merchantCode });
};
export const getCategory = (id, merchantCode) => {
  return post(`api/categories/${id}`, { merchantCode });
};
export const saveCategory = (id, merchantCode, category) => {
  return put(`api/categories/${id}`, { merchantCode, category });
};
export const deleteCategory = (id, merchantCode) => {
  return deleteHttp(`api/categories/${id}`, { merchantCode });
};
export const uploadCategoryPhoto = (id, merchantCode, file) => {
  var data = new FormData();
  data.append("file", file);
  data.append("merchantCode", merchantCode);

  return postFile(`api/categories/${id}/upload`, data);
};
export const deleteCategoryPhoto = (id, merchantCode) => {
  return deleteHttp(`api/categories/${id}/upload`, { merchantCode });
};

export const reoderCategories = (merchantCode, source, position, target) => {
  return post(`api/categories/reorder`, {
    merchantCode,
    source,
    position,
    target,
  });
};

export const getPeriods = (merchantCode) => {
  return post("api/periods", { merchantCode });
};
export const getPeriod = (id, merchantCode) => {
  return post(`api/periods/${id}`, { merchantCode });
};
export const savePeriod = (id, merchantCode, period) => {
  return put(`api/periods/${id}`, { merchantCode, period });
};
export const deletePeriod = (id, merchantCode) => {
  return deleteHttp(`api/periods/${id}`, { merchantCode });
};

export const getPriceGrid = (merchantCode) => {
  return post("api/price-grid", { merchantCode });
};
export const getPrice = (id, merchantCode) => {
  return post(`api/price-grid/${id}`, { merchantCode });
};
export const savePrice = (id, merchantCode, price) => {
  return put(`api/price-grid/${id}`, { merchantCode, price });
};
export const deletePrice = (id, merchantCode) => {
  return deleteHttp(`api/price-grid/${id}`, { merchantCode });
};
export const reorderPriceGrid = (merchantCode, source, position, target) => {
  return post(`api/price-grid/reorder`, {
    merchantCode,
    source,
    position,
    target,
  });
};
export const setDefaultPrice = (id, merchantCode) => {
  return post(`api/price-grid/default/${id}`, { merchantCode });
};

export const getProductsUnavailabilities = (merchantCode) => {
  return post("api/unavailabilities", { merchantCode });
};
export const getProductUnavailabilities = (id, merchantCode) => {
  return post(`api/unavailabilities/${id}`, { merchantCode });
};
export const saveProductUnavailabilities = (id, merchantCode, product) => {
  return put(`api/unavailabilities/${id}`, { merchantCode, product });
};

export const getSalesInformations = (merchantCode) => {
  return post("api/sales-informations", { merchantCode });
};
export const reorderSalesInformations = (
  merchantCode,
  source,
  position,
  target
) => {
  return post(`api/sales-informations/reorder`, {
    merchantCode,
    source,
    position,
    target,
  });
};
export const getSalesInformation = (id, merchantCode) => {
  return post(`api/sales-informations/${id}`, { merchantCode });
};
export const saveSalesInformation = (id, merchantCode, salesInformation) => {
  return put(`api/sales-informations/${id}`, {
    merchantCode,
    salesInformation,
  });
};
export const deleteSalesInformation = (id, merchantCode) => {
  return deleteHttp(`api/sales-informations/${id}`, { merchantCode });
};



// WEBPACK FOOTER //
// ./src/services/api.js